<template>
  <p>© {{ new Date().getFullYear() }} Weightmans LLP</p>
</template>

<style lang="scss" scoped>
p {
  font-size: var(--step--1);
  opacity: 0.6;
}
</style>
